export default {
	CLEAR: "parcelamentoRateioClear",
	SET: "parcelamentoRateioSet",
};
